export { default as withPinchZoom } from './pinchZoom';
